// extracted by mini-css-extract-plugin
export default {"container":"AdviserProfileTopNav_container__OQwn4","swiperPagination":"AdviserProfileTopNav_swiperPagination__+KTSu","navButton":"AdviserProfileTopNav_navButton__s3W+W"};